export default {
    getAllOffers: state => {
        return state.offers.data;
    },
    getAllOfferCategories: state => {
        return state.offers.categories;
    },
    getAllOfferLocations: state => {
        return state.offers.locations;
    },
    getOffersIsLoading: state => {
        return state.offers.dataIsLoading || state.offers.categoriesIsLoading || state.offers.locationsIsLoading;
    },

};